export default "__VITE_ASSET__DnvkOl85__"